var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_padding_top_small"},[_c('div',{staticClass:"signature_field"},[(_vm.signatureData != 'null' && _vm.signatureData != 'N/A')?_c('img',{staticClass:"image_layout",attrs:{"src":_vm.signature,"height":"60"}}):_c('p',[_vm._v("N/A")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }